"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkUpdateApiImpl = void 0;
const tslib_1 = require("tslib");
const ApiBase_1 = require("./ApiBase");
const ModuleConstants = tslib_1.__importStar(require("../../Utilities/Constants/ModuleConstants"));
const BulkUpdateRedux = tslib_1.__importStar(require("../../Redux/ActionsReducers/BulkUpdateRedux"));
const SystemRedux = tslib_1.__importStar(require("../../Redux/ActionsReducers/SystemRedux"));
class BulkUpdateApiImpl extends ApiBase_1.ApiBase {
    getBulkUpdateValue() {
        return this.getAdaptableState().System.BulkUpdateValue;
    }
    openBulkUpdateSettingsPanel() {
        this.showModulePopup(ModuleConstants.BulkUpdateModuleId);
    }
    showBulkUpdatePopup() {
        this.openBulkUpdateSettingsPanel();
    }
    applyBulkUpdate(cellUpdateRequests) {
        this.dispatchAction(BulkUpdateRedux.BulkUpdateApply(cellUpdateRequests));
    }
    setBulkUpdateValue(bulkUpdateValue) {
        this.dispatchAction(SystemRedux.BulkUpdateChangeValue(bulkUpdateValue));
    }
}
exports.BulkUpdateApiImpl = BulkUpdateApiImpl;
